import React from 'react';

const PartnerSection: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="layout-container max-w-[1360px] mx-auto px-5 flex flex-col gap-14">
        {/* Our Story Section */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14">
          <div className="w-full lg:w-[45%] flex flex-col items-start gap-5">
            <div className="px-3 py-1 rounded-full border border-[#B8B8B8] inline-flex items-center justify-center">
              <span className="text-[#919191] text-[10px] font-description font-normal uppercase tracking-wider">Our Story</span>
            </div>
            <h2 className="font-title text-[28px] md:text-[36px] font-medium leading-[1.1] text-[#212121]">
              We Didn't Start Here. But This Is Exactly Where We Were Always Going.
            </h2>
            <p className="font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191]">
              The story of Bao Technologies is a story about clarity. Not the kind you're born with, but the kind you earn by trying things, paying attention, and being honest enough to change direction when the evidence is clear.
            </p>
          </div>

          <div className="w-full lg:w-[55%] border border-[#E4E4E4] rounded-[20px] p-5 md:p-6">
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1 mb-1">
                <span className="text-[#919191] text-[12px] md:text-[13px] font-title font-medium">The Moment We Got Focused </span>
                <span className="text-[#212121] text-[26px] md:text-[32px] font-title font-medium leading-[1]">In 2025</span>
              </div>
              <p className="font-description text-[12px] md:text-[13px] font-light leading-[1.55] text-[#919191]">
                We made a decision that felt uncomfortable at the time and obvious in hindsight. We let go of the travel services and the general training offerings, and we went all in on what we do best: building software for businesses and helping them grow through digital marketing.
              </p>
              <p className="font-description text-[12px] md:text-[13px] font-light leading-[1.55] text-[#919191]">
                That wasn't about shrinking. It was about going deeper. When you stop trying to be everything to everyone, you get very good at the thing you've actually chosen. And we chose to focus on B2B businesses the operators, the founders, the teams building something real and give them the tools and visibility they need to compete.
                <br /><br />
                We renamed. We rebuilt. We recommitted. And Bao Technologies, as it exists today, was born from that conviction.
              </p>
            </div>
          </div>
        </div>

        {/* <p className="text-center font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191]">
          We also run{' '}
          <a
            href="https://baocademy.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2776EA] font-medium underline underline-offset-2 hover:opacity-80"
          >
            Bao Academy
          </a>
          , our training arm for Cameroonian tech talent.
        </p> */}
      </div>
    </section>
  );
};

export default PartnerSection;
